/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { object, func, number, bool } from "prop-types";
import { LoadMoreStoriesBase, LoadMoreCollectionStories } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import { NotFoundPage } from "../not-found";
import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import { staticTexts } from "../../utils/Translate";
import TagStorySearch from "../../molecules/TagStorySearch";
import { setVerticalMenuBar, setMobileFilter } from "../../helper/actions";
import { googleTagEvents } from "../../utils/utils";

import "./tag.m.css";

const NO_OF_STORIES_TO_LOAD = 6;

function TagPageBase({
  data,
  publisherAttributes,
  setVerticalMenuBar,
  isVerticalMenubar,
  setMobileFilter,
  isMobileFilter,
}) {
  const { tag, localNewsData, stories, districtNewsType } = data;
  const { lang } = publisherAttributes;
  const { localNewsDivisionSlug, localNewsDistrictSlug, localNewsSubDistrictSlug } = localNewsData;
  const [isMobile, setIsMobile] = useState(false);

  if (!tag) {
    return <NotFoundPage />;
  }

  const imgRegex = new RegExp("<img[^>]*?>", "g");
  const tagDescription = tag.description ? tag.description.replace(tag.description.match(imgRegex), "") : "";
  const storyFields =
    "headline,subheadline,author-name,author-id,authors,last-published-at,hero-image-metadata,hero-image-s3-key,slug,id,story-template,tags,url,cards,alternative,metadata";

  const contentStyleName = `content ${
    localNewsDivisionSlug || tag.slug === "district-news" ? "local-news-content" : ""
  }`;

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(true);
  }, []);

  const toggleFilterSearch = () => {
    isMobile && setVerticalMenuBar(!isVerticalMenubar) && setMobileFilter(!isMobileFilter);
  };

  const getStories = () => {
    if (stories.length > 0) {
      if (districtNewsType) {
        return (
          <LoadMoreCollectionStories
            collectionSlug={tag.slug}
            template={MoreCollectionStories}
            data={data}
            numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
            fields={storyFields}
          />
        );
      }

      return (
        <LoadMoreStoriesBase
          template={MoreCollectionStories}
          fields={storyFields}
          params={{ "tag-slugs": tag.slug }}
          data={data}
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      );
    }

    return <div styleName={`no-stories ${lang}-no-stories`}>No stories found !!</div>;
  };

  // NTG
  const [scroll, setScroll] = useState(0);
  const scrollEventTrigger = (value) => {
    googleTagEvents("article-milestone", tag.slug, value);
  };
  useEffect(() => {
    const scrollCalculate = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded >= 25 && scrollPercentRounded < 50) {
        if (scroll < 25) {
          setScroll(25);
          scrollEventTrigger(25);
        }
      } else if (scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        if (scroll < 50) {
          setScroll(50);
          scrollEventTrigger(50);
        }
      } else if (scrollPercentRounded >= 75 && scrollPercentRounded < 99) {
        if (scroll < 75) {
          setScroll(75);
          scrollEventTrigger(75);
        }
      } else if (scrollPercentRounded >= 99) {
        if (scroll < 99) {
          setScroll(99);
          scrollEventTrigger(100);
        }
      }
    };
    if (window) {
      window.addEventListener("scroll", scrollCalculate);
      return () => {
        window.removeEventListener("scroll", scrollCalculate);
      };
    }
  }, [scroll]);

  const getTagInfo = () => {
    if (localNewsSubDistrictSlug) {
      return "উপজেলা";
    } else if (localNewsDistrictSlug) {
      return "জেলা";
    } else if (localNewsDivisionSlug) {
      return "বিভাগ";
    }
    return staticTexts(lang).tag;
  };

  return (
    <React.Fragment>
      <div styleName={contentStyleName}>
        <div styleName="tag-name">
          {(getTagInfo() === "উপজেলা" || getTagInfo() === "জেলা" || getTagInfo() === "বিভাগ") && (
            <Headline text={getTagInfo()} headerLevel={3} headlineType={27} className="name" />
          )}
          {isMobile && (localNewsDivisionSlug || tag.slug === "district-news") && (
            <div
              styleName={`filter-button ${tag.slug === "district-news" ? "district-filter" : ""}`}
              onClick={toggleFilterSearch}
            >
              {staticTexts(lang).filterText}
            </div>
          )}
        </div>
        {tag ? (
          <React.Fragment>
            <Headline text={tag.name} headerLevel={1} headlineType={38} className="title" />
            {tagDescription ? (
              <span className="sub-title" dangerouslySetInnerHTML={{ __html: tagDescription }}></span>
            ) : null}
          </React.Fragment>
        ) : null}
      </div>
      <div styleName={localNewsDivisionSlug || tag.slug === "district-news" ? "local-news-content-2" : ""}>
        {(localNewsDivisionSlug || tag.slug === "district-news") && (isMobileFilter || !isMobile) && (
          <TagStorySearch
            className="local-news-tag-search"
            {...localNewsData}
            showHeading={tag.slug !== "district-news"}
            toggleFilterSearch={toggleFilterSearch}
          />
        )}
        {getStories()}
      </div>
    </React.Fragment>
  );
}

const MoreCollectionStories = ({ stories, onLoadMore, noMoreStories, loading }) => (
  <Stories2AdWithLoadMore
    list={stories}
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD <= stories.length && !noMoreStories}
  />
);

TagPageBase.propTypes = {
  data: object,
  config: object,
  publisherAttributes: object,
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  setMobileFilter: func,
  isMobileFilter: bool,
};

MoreCollectionStories.propTypes = {
  stories: object,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
  isMobileFilter: get(state, ["filterReducer", "isMobileFilter"], false),
});

const mapDispatchToProps = (dispatch) => ({
  setVerticalMenuBar: (flag) => dispatch(setVerticalMenuBar(flag)),
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
});

const TagPage = connect(mapStateToProps, mapDispatchToProps)(TagPageBase);

export { TagPage };
